
export function updateArray<T>(
    arr: Array<T>,
    update: {
        with(item: T): T;
        where(item: T): boolean;
    }
): Array<T>
{
    return arr.map(item => update.where(item) ? update.with(item) : item);
}
